import React, { Component } from 'react'
import PropTypes from 'prop-types';

export class DummyRow extends Component {
  constructor(props){
    super(props);
  }
  render() {
    const { data, cellCount=1, perPage = 10 } = this.props;
    let length = data && data.length ? data.length : 10;
        length = ( perPage - length ) > 0 ? perPage - length : 0;
    if( length > 0 ){
      let rows = [];
      for (let index = 0; index < cellCount; index++) {
        rows.push(<td style={{background: "white"}}></td>)
      }
      let list = [];
      for (let index = 0; index < length; index++) {
        list.push(
          <tr key={index} style={{background: "white"}}>
            {rows}
          </tr>
        )
      }
      return (list)

    } else {
      return(
        <React.Fragment/>
      )
    }
  }
}
DummyRow.contextTypes = {
  __: PropTypes.func
};

export default DummyRow;



// WEBPACK FOOTER //
// src/modules/common/components/DummyRow.js